export default __webpack_public_path__ + "static/media/two_of_cups.7011d0c4.png";